module.exports = __webpack_public_path__ + "static/media/YM77_1.0d891e0f.jpg";